<h2 class="modal-title" style="margin-top: 3%; margin-left: 25px; font-weight: bold;">
  Editer plannification du rapport
</h2>
<hr style="
  border: 1px solid #262756;
  opacity: 0.23;
  top: 247px;
  left: 442px;
  width: 95%;
  height: 0px;
"/>
<div class="mb-2 mt-5 pl-3">
  <form class="mt-4" [formGroup]="registerFormUpdate" (submit)="submitForm()">
    <div class="mb-2 mt-5 pl-3">
      <div class="col-md-12">
        <div class="row pb-4 w-100">
          <div class="col-5">
            <div class="col-md-12 pr-0">
              <h1 class="p-2 mb-3 plan">
                <!-- <img
                  src="https://img.icons8.com/fluent/25/000000/task-planning.png"
                /> -->
                Plannification
              </h1>
            </div>

            <div class="col-md-12 mb-3">
              <form>
                <mat-form-field class="disable"
                                appearance="fill"
                                style="width: 100%"
                                (click)="hiddencontenurep()"
                >
                  <mat-label
                  >Sélectionner un rapport à plannifier {{rapport}}</mat-label
                  >

                  <input
                    type="text"
                    aria-label="Number"
                    matInput
                    (keyup)="applyFilter2($event)"
                    formControlName="report_filter"
                    (click)="hiddencontenu2rep()"
                    [formControl]="myControl1"
                    [matAutocomplete]="autoo"
                    [(ngModel)]="rapport"
                  />

                  <button mat-button matSuffix mat-icon-button>
                    <mat-icon
                      placement="bottom"
                      ngbTooltip="Actualiser la liste des rapports favoris"
                      (click)="refrechrepos()"
                    >refresh
                    </mat-icon>
                  </button>
                  <button
                    mat-button
                    matSuffix
                    mat-icon-button
                    (click)="hiddencontenurep()"
                  >
                    <mat-icon
                      placement="bottom"
                      ngbTooltip="Lister les rapports favoris"
                    >filter_list
                    </mat-icon
                    >
                  </button>

                  <mat-autocomplete
                    autoActiveFirstOption
                    #autoo="matAutocomplete"
                  >
                    <table
                      class="table-hover"
                      mat-table
                      [dataSource]="dataSourcetrep"
                    >
                      <ng-container matColumnDef="position1">
                        <th mat-header-cell *matHeaderCellDef>Rapport.</th>
                        <td
                          (click)="getContact_notif()"
                          mat-cell
                          *matCellDef="let elementt"
                          [ngClass]="{
                        highlight: selectedRowIndex2 == elementt.id
                      }"
                          (click)="getItemDetails3(elementt)"
                        >
                          <b class="colorTable">
                            Rapport.{{ elementt.name }}
                          </b>
                          <br/>
                          Période.{{ elementt.filter }} <br/>
                        </td>
                      </ng-container>

                      <tr
                        class="d-none"
                        mat-header-row
                        *matHeaderRowDef="displayedColumnrep"
                      ></tr>
                      <tr
                        mat-row
                        *matRowDef="let elementt; columns: displayedColumnrep"
                      ></tr>
                    </table>

                    <mat-paginator
                      #secondPaginator2
                      [pageSize]="pageSize"
                      [pageSizeOptions]="pageSizeOptions"
                      showFirstLastButtons
                    >
                    </mat-paginator>

                    <mat-option class="d-none"></mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </form>
            </div>

            <div class="col-md-12 mb-3">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Choisir une fréquence</mat-label>
                <mat-select
                  disableRipple [(value)]="selected"
                  (selectionChange)="frequence_Change($event)"
                  formControlName="frequency"
                  [(ngModel)]="frequence"
                >
                  <mat-option value="1">Une fois</mat-option>
                  <mat-option value="d">Une fois par jour</mat-option>
                  <mat-option value="w">Une fois par semaine</mat-option>
                  <mat-option value="m">Une fois par mois</mat-option>

                  <mat-option value="2m">Deux fois par mois</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-12 mb-3">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Choisir une période</mat-label>
                <mat-select
                  disableRipple
                  formControlName="period"
                  [(ngModel)]="periode"
                >
                  <mat-option
                    value="today"
                    *ngIf="frequence == '1' || frequence == 'd'"
                  >Jour en cours
                  </mat-option
                  >
                  <mat-option
                    value="previous day"
                    *ngIf="frequence == '1' || frequence == 'd'"
                  >Jour précédent
                  </mat-option>
                  <mat-option
                    value="this week"
                    *ngIf="frequence == '1' || frequence == 'w' || frequence == '2m'"
                  >
                    Semaine en cours
                  </mat-option
                  >
                  <mat-option
                    value="7 days ago"
                    *ngIf="frequence == '1' || frequence == 'w' "
                  >7 derniers jours
                  </mat-option>

                  <mat-option
                    value="1 week ago"
                    *ngIf="frequence == '1' || frequence == 'w' || frequence == '2m'"
                  >
                    Semaine précédente 1
                  </mat-option
                  >
                  <mat-option
                    value="2 week ago"
                    *ngIf="frequence == '1' || frequence == 'w' || frequence == '2m'"
                  >
                    Semaine précédente 2
                  </mat-option
                  >
                  <mat-option
                    value="3 weeks ago"
                    *ngIf="frequence == '1' || frequence == 'w' || frequence == '2m'"
                  >
                    Semaine précédente 3
                  </mat-option
                  >
                  <mat-option
                    value="this month"
                    *ngIf="frequence == '1' || frequence == 'm' "
                  >mois en cours
                  </mat-option>
                  <mat-option
                    value="previous month"
                    *ngIf="frequence == '1' || frequence == 'm' "
                  >mois précédent
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-12 mb-3" *ngIf="frequence == '1'">
              <!--  <mat-form-field class="w-100" appearance="fill">
      <input matInput [owlDateTimeTrigger]="dt" [min]="min" [owlDateTime]="dt" formControlName="date" [(ngModel)]="date">
    </mat-form-field>
      <owl-date-time [startAt]="startAt" [pickerType]="'calendar'" #dt></owl-date-time> -->

              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Choisissez une date</mat-label>
                <input
                  matInput
                  [min]="min"
                  [matDatepicker]="picker"
                  formControlName="date"
                  [(ngModel)]="date"
                  id="dateRapport"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker
                  startView="year"
                  [startAt]="startAt"
                ></mat-datepicker>
              </mat-form-field>
            </div>

            <div
              class="col-md-12 mb-3 minutes-gap-example"
              *ngIf="frequence == '1' || frequence == 'd' || frequence == 'w' || frequence == 'm' || frequence == '2m'"
            >
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Choisissez une heure</mat-label>
                <input
                  matInput
                  placeholder="Choisissez une heure"
                  [format]="24"
                  [(ngModel)]="heure"
                  [ngxTimepicker]="with5Gap"
                  formControlName="hour"
                  id="heureRapport"
                  readonly
                />
              </mat-form-field>

              <ngx-material-timepicker
                #with5Gap
                [minutesGap]="15"
                [enableKeyboardInput]="true"
                [theme]="darkTheme"
              >
              </ngx-material-timepicker>
            </div>

            <div class="col-md-12 mb-3" *ngIf="frequence == 'w'">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Choisir un jour  </mat-label>
                <mat-select
                  disableRipple
                  [(value)]="selected3"
                  formControlName="wkDay"
                  [(ngModel)]="wkDay"
                >
                  <mat-option [value]="1">Lundi</mat-option>
                  <mat-option [value]="2">Mardi</mat-option>

                  <mat-option [value]="3">Mercredi</mat-option>
                  <mat-option [value]="4">Jeudi</mat-option>
                  <mat-option [value]="5">Vendredi</mat-option>
                  <mat-option [value]="6">Samedi</mat-option>
                  <mat-option [value]="0">Dimanche</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="row">
              <div
                class="col-md-3"
                *ngIf="frequence == 'm' || frequence == '2m'"
              >
                <mat-slider
                  class="w-100"
                  formControlName="day1"
                  [(ngModel)]="day1"
                  (change)="updatenbrjrs($event)"
                  thumbLabel
                  [displayWith]="formatLabel"
                  tickInterval="1000"
                  min="1"
                  max="31"
                ></mat-slider>
              </div>
              <div
                class="col-md-2 mb-3 d-flex"
                style="align-items: center"
                style="font-size: large"
                *ngIf="frequence == 'm' || frequence == '2m'"
              >
                Jour {{sliderValue}}
              </div>
              <div
                class="col-md-2 mb-3 d-flex"
                style="align-items: center"
                style="font-size: large"
                *ngIf="frequence == '2m'"
              >
                <h2 class="colorTable">Et</h2>
              </div>
              <div class="col-md-3" *ngIf="frequence == '2m'">
                <mat-slider
                  class="w-100"
                  (change)="updatenbrjrs1($event)"
                  formControlName="day2"
                  [(ngModel)]="day2"
                  thumbLabel
                  [displayWith]="formatLabel1"
                  tickInterval="1000"
                  min="1"
                  max="31"
                ></mat-slider>
              </div>
              <div
                class="col-md-2 mb-3 d-flex"
                style="align-items: center"
                style="font-size: large"
                *ngIf="frequence == '2m'"
              >
                Jour {{sliderValue1}}
              </div>
            </div>
          </div>

          <div class="col-5 offset-2">
            <h1 class="p-2 mb-3 plan">
              <!-- <img src="https://img.icons8.com/fluent/25/000000/contacts.png" /> -->
              Contact
            </h1>

            <div class="row">
              <div class="col-md-2"></div>
              <div class="col-md-10"></div>
            </div>
            <div class="row">
              <div class="col-md-12 pr-5">
                <div class="row">
                  <div class="col-md-11 w-100">
                    <form>
                      <mat-form-field
                        appearance="fill"
                        style="width: 100%; margin-bottom: 20px"
                        (click)="hiddencontenu()"
                      >
                        <mat-label
                        >Sélectionner un contact déjà existant
                        </mat-label>

                        <input
                          type="text"
                          aria-label="Number"
                          matInput
                          (keyup)="applyFilter1($event)"
                          (click)="hiddencontenu2()"
                          [formControl]="myControl"
                          [matAutocomplete]="auto"
                        />

                        <button mat-button matSuffix mat-icon-button>
                          <mat-icon
                            placement="bottom"
                            ngbTooltip="Actualiser la liste des contacts"
                            (click)="refrech()"
                          >
                            refresh
                          </mat-icon>
                        </button>
                        <button
                          mat-button
                          matSuffix
                          mat-icon-button
                          (click)="hiddencontenu()"
                        >
                          <mat-icon
                            placement="bottom"
                            ngbTooltip="Lister les contacts"
                          >filter_list
                          </mat-icon
                          >
                        </button>

                        <mat-autocomplete
                          autoActiveFirstOption
                          #auto="matAutocomplete"
                        >
                          <table
                            class="table-hover"
                            mat-table
                            [dataSource]="dataSourcet"
                          >
                            <ng-container matColumnDef="position">
                              <th mat-header-cell *matHeaderCellDef>
                                Contact.
                              </th>
                              <td
                                (click)="getContact_notif()"
                                mat-cell
                                *matCellDef="let elementt"
                                [ngClass]="{
                          highlight: selectedRowIndex2 == elementt.id
                        }"
                                (click)="getItemDetails2(elementt)"
                              >
                                <strong>
                                  Name: {{ elementt.first_name }}
                                </strong>
                                <br/>
                                Id: {{ elementt.id }} <br/>

                                Email: {{ elementt.email }}
                              </td>
                            </ng-container>

                            <tr
                              class="d-none"
                              mat-header-row
                              *matHeaderRowDef="displayedColumnst"
                            ></tr>
                            <tr
                              mat-row
                              *matRowDef="let elementt; columns: displayedColumnst"
                            ></tr>
                          </table>

                          <mat-paginator
                            #secondPaginator
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            showFirstLastButtons
                          >
                          </mat-paginator>

                          <mat-option class="d-none"></mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </form>
                  </div>
                  <div
                    class="col-md-1 w-100"
                    style="
                      display: flex;
                      justify-content: center;
                      padding-top: 8px;
                    "
                  >
                    <img
                      data-toggle="collapse"
                      (click)="add_contact()"
                      data-target="#collapseMalasngoding"
                      aria-expanded="false"
                      aria-controls="collapseMalasngoding"
                      width="40px"
                      height="40px"
                      placement="bottom"
                      ngbTooltip="Ajouter un nouveau contact"
                      src="assets/icons/add-contact.svg"
                    />
                    <img placement="bottom" ngbTooltip="Confirmer" (click)="submitcontact()"
                         *ngIf="new_contact == true && registerFormContact.valid" width="40px" height="40px"
                         src="https://img.icons8.com/ios/64/4a90e2/ok--v1.png"/>
                    <!--                    <img-->
                    <!--                      placement="bottom"-->
                    <!--                      ngbTooltip="Confirmer"-->
                    <!--                      (click)="submitcontact()"-->
                    <!--                      *ngIf="new_contact == true && registerFormContact.valid"-->
                    <!--                      width="40px"-->
                    <!--                      height="40px"-->
                    <!--                      src="assets/icons/add-contact.svg"-->
                    <!--                    />-->
                  </div>
                </div>
                <div class="collapse" id="collapseMalasngoding">
                  <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                      <mat-form-field
                        *ngIf="new_contact == false"
                        appearance="fill"
                        style="width: 100%; margin-bottom: 20px"
                      >
                        <mat-label>Contacts</mat-label>
                        <mat-select [formControl]="contacts">
                          <mat-option
                            *ngFor="let contact of contactList"
                            [value]="contact"
                          >{{contact.first_name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-md-4"></div>
                  </div>
                  <form
                    class="mt-4"
                    [formGroup]="registerFormContact"
                    (submit)="submitcontact()"
                  >
                    <div class="row" *ngIf="new_contact == true">
                      <div class="col-md-6" style="margin-bottom: 20px">
                        <mat-form-field
                          class="example-full-width"
                          appearance="fill"
                          style="width: 100%"
                        >
                          <mat-label>Nom</mat-label>
                          <input
                            matInput
                            formControlName="last_name"
                            required
                            [errorStateMatcher]="matcher"
                          />
                          <mat-error
                            *ngIf="registerFormContact.get('last_name').hasError('pattern')"
                          >Veuillez saisir une format valide !
                          </mat-error>
                          <mat-error
                            *ngIf="registerFormContact.get('last_name').hasError('required')"
                          >
                            Nom est <strong>Obligatoire</strong>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-md-6" style="margin-bottom: 20px">
                        <mat-form-field
                          class="example-full-width"
                          appearance="fill"
                          style="width: 100%"
                        >
                          <mat-label>Prénom</mat-label>
                          <input
                            matInput
                            formControlName="first_name"
                            required
                            [errorStateMatcher]="matcher"
                          />
                          <mat-error
                            *ngIf="registerFormContact.get('first_name').hasError('pattern')"
                          >Veuillez saisir une format valide !
                          </mat-error>
                          <mat-error
                            *ngIf="registerFormContact.get('first_name').hasError('required')"
                          >
                            Prénom est <strong>Obligatoire</strong>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="row" *ngIf="new_contact == true">
                      <div class="col-md-6" style="margin-bottom: 20px">
                        <mat-form-field
                          class="example-full-width"
                          appearance="fill"
                          style="width: 100%"
                        >
                          <mat-label>Courrier électronique</mat-label>
                          <input
                            matInput
                            formControlName="email"
                            required
                            [errorStateMatcher]="matcher"
                          />

                          <mat-error
                            *ngIf="registerFormContact.get('email').hasError('email')"
                          >Veuillez saisir une format valide !
                          </mat-error>
                          <mat-error
                            *ngIf="registerFormContact.get('email').hasError('required')"
                          >
                            Email est <strong>Obligatoire</strong>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-md-6" style="margin-bottom: 20px">
                        <mat-form-field
                          class="example-full-width"
                          appearance="fill"
                          style="width: 100%"
                        >
                          <mat-label>Numéro de téléphone</mat-label>
                          <input
                            matInput
                            type="number"
                            formControlName="gsm_number"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12 col-md-12">
            <table
              mat-table
              [dataSource]="dataSourceC"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef></th>

                <td
                  (click)="selection.toggle(element)"
                  mat-cell
                  *matCellDef="let element"
                  formArrayName="key"
                >
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)"
                    [aria-label]="checkboxLabel(element)"
                    [formControlName]="element"
                  >
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID.</th>
                <td mat-cell *matCellDef="let element">{{element.id}}</td>
              </ng-container>

              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef>Prénom</th>
                <td mat-cell *matCellDef="let element">
                  {{element.first_name}}
                </td>
              </ng-container>

              <ng-container matColumnDef="last_name">
                <th mat-header-cell *matHeaderCellDef>Nom</th>
                <td mat-cell *matCellDef="let element">
                  {{element.last_name}}
                </td>
              </ng-container>

              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td
                  mat-cell
                  *matCellDef="let element ; let i= index"
                  style="justify-content: end"
                >
                  <img
                    (click)="Delete_contact(i)"
                    placement="left"
                    ngbTooltip="Supprimer contact"
                    width="25%"
                    src="assets/icons/icon-delete.svg"
                  />
                </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>email</th>
                <td mat-cell *matCellDef="let element">{{element.email}}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class=" justify-content-end d-flex" style="margin-right: 5%; margin-bottom: 40px;">
  <a class="savebtn mr-2" type="submit" (click)="submitForm()">Enregistrer</a>
  <a class="cancelbtn mr-2" type="submit" (click)="onNoClick()">Annuler</a>
</div>
